/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type HexSelectionFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly canDelete: boolean;
  readonly canEditMetadata: boolean;
  readonly canSetOwner: boolean;
  readonly canUseApp: boolean;
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
  } | null;
  readonly categories: ReadonlyArray<{
    readonly __typename: "Category";
    readonly id: c.CategoryId;
  }>;
};

export const HexSelectionFragmentDoc = /*#__PURE__*/ gql`
  fragment HexSelectionFragment on Hex {
    id
    canDelete
    canEditMetadata
    canSetOwner
    canUseApp
    status {
      id
    }
    categories {
      id
    }
  }
`;
